module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0081.jpg?v=d17d4b62";